export class NavigationSubMenuButton {
  private targets?: NodeListOf<HTMLButtonElement> | null;
  constructor() {
    this.init();
  }

  private init() {
    this.cleanup();
    this.targets = document.querySelectorAll<HTMLButtonElement>(
      '#header-navigation .menu-item button'
    );
    if (this.targets.length > 0) {
      this.targets.forEach((target) => {
        target.addEventListener('click', this.handleClick);
      });
    }
  }

  private cleanup() {
    if (this.targets && this.targets.length > 0) {
      this.targets.forEach((target) => {
        target.removeEventListener('click', this.handleClick);
      });
    }
  }

  private handleClick = (event: MouseEvent) => {
    const target = event.currentTarget as HTMLButtonElement;
    const currentAriaExpanded = target.getAttribute('aria-expanded');
    target.setAttribute(
      'aria-expanded',
      currentAriaExpanded === 'true' ? 'false' : 'true'
    );
  };
}
